import React from 'react';
import LanguagePickerNav from '../ComponentsBrafab/LanguagePickerNav';

const LanguagePickerNavigationContainer = (props) => {
    return (
        <LanguagePickerNav isMobile={props.isMobile} />
    );
};

export default LanguagePickerNavigationContainer;
